import { addStyles } from 'ethcss'
import { colors, IStyles } from '../../../theme'
import { color } from 'theme/tokens/color'

const modBusSettings: IStyles = {
    switchWrapper: {
        display: 'flex',
    },
    switchCaption: {
        marginRight: 14,
    },
    wrapper: {
        marginTop: 21,
    },
    disabled: {
        opacity: 0.5,
    },
    button: {
        marginBottom: 20,
    },
    border: {
        border: `1px solid ${color.borderDarkPrimary}`,
        padding: '10px',
        borderRadius: '10px',
    },
}

addStyles(modBusSettings)
export default modBusSettings
